import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Image } from 'antd';

import { Modal } from '@/shared/ui/modal';

import MultipleDevicesImage from '@/shared/assets/images/multiple-devices.png';

import cls from './auth-failure-popup.module.css';

interface AuthFailurePopupProps {
    isOpen: boolean;
    onClose: () => void;
    onRetry?: () => void;
}

export const AuthFailurePopup = memo((props: AuthFailurePopupProps) => {
    const { isOpen, onClose, onRetry } = props;
    const { t } = useTranslation();

    const handleRetry = useCallback(() => {
        onRetry?.();
        onClose();
    }, [onRetry, onClose]);

    const handleClose = useCallback(() => {
        onClose();
    }, [onClose]);

    const secondaryAction = onRetry
        ? {
              callback: handleRetry,
              label: t('authFailure.retry'),
          }
        : undefined;

    return (
        <Modal
            content={
                <div className={cls.content}>
                    <div className={cls.imageContainer}>
                        <Image
                            className={cls.image}
                            preview={false}
                            src={MultipleDevicesImage}
                        />
                    </div>
                    <p>{t('authFailure.description')}</p>
                </div>
            }
            isOpen={isOpen}
            onClose={handleClose}
            primaryAction={{
                callback: handleClose,
                label: t('authFailure.loginAgain'),
            }}
            {...(secondaryAction && { secondaryAction })}
            title={t('authFailure.title')}
        />
    );
});

AuthFailurePopup.displayName = 'AuthFailurePopup';
